import { useTranslation } from 'react-i18next';
import { useToastStore, type ToastKind } from '@/lib/toast';

const ESTILO: Record<ToastKind, string> = {
  error: 'border-red-400/40 bg-red-500/10 text-red-100',
  success: 'border-emerald-400/40 bg-emerald-500/10 text-emerald-100',
  info: 'border-vyxora-cyan-400/40 bg-vyxora-cyan-400/10 text-vyxora-text-light',
};

/**
 * Montado uma vez no Root. Recebe os erros globais do queryClient — por isso as telas
 * não precisam mais renderizar erro de mutation cada uma por conta própria.
 */
export function Toaster() {
  const { t } = useTranslation('app');
  const items = useToastStore((s) => s.items);
  const dismiss = useToastStore((s) => s.dismiss);

  if (items.length === 0) return null;

  return (
    <div
      className="pointer-events-none fixed bottom-4 right-4 z-[100] flex w-[min(24rem,calc(100vw-2rem))] flex-col gap-2"
      role="status"
      aria-live="polite"
    >
      {items.map((item) => (
        <div
          key={item.id}
          className={`pointer-events-auto flex items-start gap-3 rounded-lg border p-3 text-sm shadow-2xl backdrop-blur-sm ${ESTILO[item.kind]}`}
        >
          <span className="flex-1">{item.text}</span>
          <button
            onClick={() => dismiss(item.id)}
            className="shrink-0 rounded px-1 opacity-60 transition hover:opacity-100"
            aria-label={t('comum.fecharAviso')}
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
